export default __webpack_public_path__ + "static/media/IMG_2259.e9858855.jpg";